import { createFileRoute } from '@tanstack/react-router'

import { VerifyEmailPage } from '@/features/auth/components/verify-email-page'

/**
 * The email-change link page. The path is compiled into the backend
 * (`auth.frontend.verify_email_path`) — renaming it 404s every verification email.
 */
export const Route = createFileRoute('/verify-email')({
  component: VerifyEmailPage,
})
